import { LoginV4Component } from "../app/components/login-views/login-v4/login-v4.component";

export const environment = {
    production: false,
    language: "sl",
    wgProfileHost: "http://ove5-api.borzen.si",
    wgPlatformHost: "http://ove5-platform.borzen.si",

    loginComponent: LoginV4Component,
    projIcon: "/assets/project-custom/images/logo.png",
    sidebarIcon: "/assets/project-custom/images/logo.png",
    projectCode: "BORZEN_OVE5",
    projectName: "",
    locale: 'sl-SI',
    useRouteAndMasterpageCache: true,
    ADLoginEnabled: false,
    dateFormat: 'DD.MM.YYYY',
    navigateAwayPopupEnabled: true,
    useEtag: true,
    newRegistrationLinkDocument: "",
    maxChunkNumber: 200,
    maxFileSizeInMb: 4,
    maxRecordNumberPerPageListing: 30,
    cacheEnabled: false,
    version: '1.1.0',
    showOnlyUserInHeader: true,
    googleClientId: "344277045222-6f4buif3nug5cna5bso44l05pdm6h2em.apps.googleusercontent.com",
    useOldSearchViewFeature:false,
    useInlineSearch:false,
    usernameAlwaysToLower:false,
    useNotFoundComponent:true,
    maxFileSizeInMbInMessenger:5,
    projectSidebarName:""
};
